import { render, staticRenderFns } from "./BaseSubscriptionForm.vue?vue&type=template&id=2b9f2116&scoped=true"
import script from "./BaseSubscriptionForm.vue?vue&type=script&lang=js"
export * from "./BaseSubscriptionForm.vue?vue&type=script&lang=js"
import style0 from "./BaseSubscriptionForm.vue?vue&type=style&index=0&id=2b9f2116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f2116",
  null
  
)

export default component.exports